import React, { useEffect, useState } from "react";
import axios from "axios";
import ApiDataBase from "server";
import UseContext from "hooks/useContext";
import SectionWrapper, {
    FormField,
    inputClassName,
} from "pages/createMission/components/SectionWrapper";
import AddressGeoApi from "components/AddressGeoApi/AddressGeoApi";
import Tooltip from "components/tooltips/Tooltips";
import { InformationIcon } from "assets/icons";

const LocationSalaryTemplate = () => {
    const { templateData, setTemplateData, companyData } = UseContext();
    const [address, setAddress] = useState(templateData.location || "");
    const [smic, setSmic] = useState("");
    const [addressFieldMode, setAddressFieldMode] = useState({
        canUseCompanyAddress: false,
        usingCompanyAddress: false,
    });

    const addressFormLabel =
        addressFieldMode.canUseCompanyAddress &&
        addressFieldMode.usingCompanyAddress
            ? "Adresse"
            : "Rechercher un lieu";

    useEffect(() => {
        ApiDataBase.getMinimumWage(
            (data) => {
                if (data?.hourly?.gross) setSmic(data.hourly.gross);
            },
            (err) => console.log(err)
        );
    }, []);

    useEffect(() => {
        if (
            address &&
            typeof address === "object" &&
            Object.keys(address).length > 0
        ) {
            setTemplateData((prev) => ({ ...prev, location: address }));
        }
    }, [address, setTemplateData]);

    useEffect(() => {
        if (
            (!templateData.location ||
                (typeof templateData.location === "object" &&
                    Object.keys(templateData.location).length === 0)) &&
            companyData.location
        ) {
            const abortController = new AbortController();
            axios({
                method: "get",
                url: `${process.env.REACT_APP_API_URL}address/${companyData.location}`,
                withCredentials: true,
                signal: abortController.signal,
            })
                .then((res) => {
                    if (res.data) setAddress(res.data);
                })
                .catch((err) => {
                    if (
                        err.code !== "ECONNABORTED" &&
                        err.code !== "ERR_CANCELED" &&
                        err.name !== "CanceledError"
                    )
                        console.log(err);
                });
            return () => abortController.abort();
        }
    }, [templateData.location, companyData.location]);

    const handleSalaryChange = (value) => {
        setTemplateData((prev) => ({ ...prev, salary: value }));
    };

    const toggleIndexed = () => {
        setTemplateData((prev) => {
            const next = !prev.isIndexedToMinimumWage;
            return {
                ...prev,
                isIndexedToMinimumWage: next,
                salary: next && smic ? smic : prev.salary,
            };
        });
    };

    return (
        <SectionWrapper
            title="Lieu & Rémunération"
            description="Adresse de la mission et taux horaire associés à cette fiche de poste."
        >
            <FormField label={addressFormLabel}>
                <AddressGeoApi
                    addressGeoValue={setAddress}
                    addressValue={address}
                    isAddressCompany={true}
                    page={"missionTemplate"}
                    embeddedInFormField
                    onAddressModeChange={setAddressFieldMode}
                />
            </FormField>
            <FormField label="Taux horaire brut">
                <div className="flex flex-col">
                    <div className="relative">
                        <input
                            name="salary"
                            value={templateData.salary}
                            onChange={(e) => handleSalaryChange(e.target.value)}
                            className={`${inputClassName} pr-16`}
                            type="text"
                            placeholder="Ex: 12.50"
                            disabled={templateData.isIndexedToMinimumWage}
                        />
                        <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                            <span className="ft-sm text-gray-500">€/heure</span>
                        </div>
                        <Tooltip
                            text={
                                "Quand la fiche est indexée au SMIC, le taux suit automatiquement la dernière valeur officielle."
                            }
                            placement="bottom"
                        >
                            <div className="absolute inset-y-0 right-16 z-20 flex items-center px-2 cursor-pointer">
                                <InformationIcon color={"#2CAFFF"} wh={15} />
                            </div>
                        </Tooltip>
                    </div>
                    <div className="flex justify-end my-2">
                        <label
                            htmlFor="mission-template-indexed-smic"
                            className="inline-flex items-center gap-2 cursor-pointer ft-sm font-normal text-gray-700 select-none"
                        >
                            <input
                                id="mission-template-indexed-smic"
                                type="checkbox"
                                checked={!!templateData.isIndexedToMinimumWage}
                                onChange={toggleIndexed}
                                className="checkbox-yellow-sm"
                            />
                            <span>
                                SMIC ({smic ? `${smic}€/h` : "—"})
                            </span>
                        </label>
                    </div>
                </div>
            </FormField>
        </SectionWrapper>
    );
};

export default LocationSalaryTemplate;
